import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GPS } from "../../util/geo";
import { CubeSections, Intermediate, RReport } from "../report/Report";
import { fCoords } from "../report/sections/util";
import { useAccount, useWorkspaces } from "../state";
import { useOwnership } from "../state/ownership";

// Publieke, read-only weergave van een gedeeld project (/shared/<token>).
// Geen login nodig: de onraadbare token is de sleutel.
const SharedReportData = ({ location: token }: { location: string }) => {
  const [state, setState] = useState<"fetching" | "fetched" | "error">("fetching");
  const [cube, setCube] = useState<any>(null);
  const [coords, setCoords] = useState<string | undefined>();
  const [error, setError] = useState<any>();
  // Een deellink toont de eigendomsinformatie altijd, zonder PDF-link.
  const ownershipRows = useOwnership(`/api/shared/${token}/ownership`);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const pr = await fetch(`/api/shared/${token}`);
        if (!pr.ok) throw new Error(`${pr.status}`);
        const workspace = await pr.json();
        if (workspace.parcels?.length) {
          setCoords(
            workspace.parcels.map((p) => fCoords(p.center.coordinates as GPS, ",")).join(",")
          );
        }
        // Toon de percelen op de kaart via de store die ProjectControl leest —
        // alleen voor anonieme bezoekers, om de projectlijst van een
        // ingelogde gebruiker niet te overschrijven.
        if (!useAccount.getState().user) {
          useWorkspaces.setState({ workspaces: [workspace], selectedWorkspaceId: workspace.id });
        }
        const cr = await fetch(`/api/shared/${token}/cube`);
        if (!cr.ok) throw new Error(`${cr.status}`);
        const data = await cr.json();
        if (active) {
          setCube(data);
          setState("fetched");
        }
      } catch (e) {
        if (active) {
          setError(e);
          setState("error");
        }
      }
    })();
    return () => {
      active = false;
    };
  }, [token]);

  if (state !== "fetched" || !cube) {
    return <Intermediate state={state} cube={cube} error={error} />;
  }
  return (
    <CubeSections cube={cube} coords={coords} ownership={{ rows: ownershipRows, named: true }} />
  );
};

export const SharedWorkspaceView = () => {
  const { token } = useParams();
  if (!token) return null;
  return <RReport location={token} updateSection={() => {}} Component={SharedReportData} />;
};
